import api from './axios';

export const getRegistrationDetails = async (registrationId, activityId) => {
    const response = await api.get(`/registrations/detail`, { params: { registrationId: Number(registrationId), activityId: Number(activityId) } });
    return response.data;
};

export const getRegistrationDetailByQRCode = async (qrCode) => {
    const response = await api.get(`/registrations/detail/qr-code`, { params: { qrCode } });
    return response.data;
}

export const getRegistrationDetailByActivityIdAndPhoneNumber = async (activityId, phoneNumber) => {
    const response = await api.get(`/registrations/detail/activity-id-phone-number`, { params: { activityId: Number(activityId), phoneNumber } });
    return response.data;
}

export const registerForEvent = async (activityId, registrationData) => {
    const formData = new FormData();
    
    // Add activityId
    formData.append('activityId', Number(activityId));
    
    // Add basic user data
    formData.append('name', registrationData.name);
    formData.append('email', registrationData.email);
    formData.append('phoneNumber', registrationData.phoneNumber);
    
    // Add form submission values
    if (registrationData.formSubmissionValues) {
        registrationData.formSubmissionValues.forEach((field, index) => {
            // If the value is a base64 string (image), append it as a file
            if (field.value && field.value.startsWith('data:image')) {
                // Convert base64 to blob
                const byteString = atob(field.value.split(',')[1]);
                const mimeString = field.value.split(',')[0].split(':')[1].split(';')[0];
                const ab = new ArrayBuffer(byteString.length);
                const ia = new Uint8Array(ab);
                
                for (let i = 0; i < byteString.length; i++) {
                    ia[i] = byteString.charCodeAt(i);
                }
                
                const blob = new Blob([ab], { type: mimeString });
                formData.append(`formSubmissionValues.${field.formFieldId}.file`, blob, `image_${field.formFieldId}.${mimeString.split('/')[1]}`);
                formData.append(`formSubmissionValues.${field.formFieldId}.value`, "");
            } else {
                formData.append(`formSubmissionValues.${field.formFieldId}.value`, field.value);
            }
        });
    }

    const response = await api.post(`/registrations/register`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
    return response.data;
};

export const verifyOTP = async (registrationId, otp) => {
    const response = await api.post(`registrations/verify-otp`, { registrationId: Number(registrationId), otp });
    return response.data;
};

export const resendOtp = async (registrationId) => {
    const response = await api.post(`/registrations/resend-otp`, { registrationId: Number(registrationId) });
    return response.data;
};

export const getQRCode = async (registrationId) => {
    const response = await api.get(`/registrations/qr-code`, { params: { registrationId: Number(registrationId) } });
    return response.data;
};

export const getRegistrationsByActivity = async (activityId) => {
    const response = await api.get(`/registrations/by-activity`, { params: { activityId: Number(activityId) } });
    return response.data;
};

export const exportRegistrationsExcel = async (activityId) => {
    const response = await api.get(`/registrations/export-excel`, { 
        params: { activityId: Number(activityId) },
        responseType: 'blob'
    });
    return response.data;
};

/** Fan member workbook: profile photo, member ID (same algorithm as MemberPage), city, QR, etc. */
export const exportFanMembersExcel = async (activityId, publicOrigin, onlyVerified = true) => {
    const response = await api.get(`/registrations/export-fan-members-excel`, {
        params: {
            activityId: Number(activityId),
            publicOrigin,
            onlyVerified: onlyVerified ? 'true' : 'false',
        },
        responseType: 'blob',
    });
    return response.data;
};

export const exportFanMembersExcelBatch = async (
    activityId,
    publicOrigin,
    onlyVerified = true,
    afterId = 0,
    limit = 250,
    part = 1,
) => {
    const response = await api.get(`/registrations/export-fan-members-excel`, {
        params: {
            activityId: Number(activityId),
            publicOrigin,
            onlyVerified: onlyVerified ? 'true' : 'false',
            afterId: Number(afterId),
            limit: Number(limit),
            part: Number(part),
        },
        responseType: 'blob',
    });
    return response.data;
};

/** @deprecated Use exportFanMembersExcel */
export const exportJemariMembersExcel = exportFanMembersExcel;

/** @deprecated Use exportFanMembersExcelBatch */
export const exportJemariMembersExcelBatch = exportFanMembersExcelBatch;

export const deleteRegistration = async (registrationId) => {
    const response = await api.delete(`/registrations/${registrationId}`);
    return response.data;
}; 